module.exports = __webpack_public_path__ + "img/ebcTradeSpace.932f06e2.png";